import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeClosedLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M2.124 8.003a1 1 0 0 1 .987.593C4.347 11.395 7.999 13 12 13s7.653-1.605 8.89-4.404a1 1 0 0 1 1.877.136l.696 2.5a1 1 0 0 1-1.926.536l-.104-.373c-.773.868-1.733 1.57-2.805 2.117l.35 1.676a1 1 0 1 1-1.957.409l-.275-1.316c-1.202.385-2.478.61-3.746.688V17a1 1 0 1 1-2 0v-2.03a15.5 15.5 0 0 1-3.746-.689l-.275 1.316a1 1 0 1 1-1.958-.41l.35-1.675c-1.071-.547-2.031-1.25-2.804-2.117l-.104.373a1 1 0 1 1-1.926-.536l.696-2.5a1 1 0 0 1 .89-.73'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeClosedLine)
export default ForwardRef
